import { Dropdown, MenuProps } from "antd";
import { DropdownProps } from "antd/es/dropdown/dropdown";
import { ItemType } from "antd/es/menu/interface";
import React from 'react';
import { propContainer } from "../../util/varibles/constants";
import styles from './style.module.scss';

interface IProps extends Partial<DropdownProps> {
    items: ItemType[] | any[] | MenuProps['items']
    visible?: boolean
    disabled?: boolean
    children?: React.ReactElement
    asChild?: boolean
    classNames?: Record<string, string>

    container?(): React.ReactElement | Element | any
}

const Menu: React.FC<IProps> = ({
    container,
    visible,
    disabled,
    trigger = ['click'],
    items,
    className,
    classNames,
    children = <div className='three-dot' />,
    asChild = false,
    ...args
}) => {

    const attr: any = {};
    if (container)
        attr.getPopupContainer = container;

    if (!visible !== undefined)
        attr.open = visible;

    return <Dropdown
        {...args}
        {...propContainer}
        {...attr}
        disabled={disabled || false}
        classNames={{ ...classNames, root: classNames?.root ? [classNames?.root, styles.dropdown].join(' ') : styles.dropdown }}
        trigger={trigger}
        menu={{ items }}
    >
        {asChild ? children : <div className={className}>
            {children}
        </div>}
    </Dropdown>;
};

export default Menu;
